import { isEmpty } from "lodash";

import { AppliedFilters } from "~/components/products-layout/components/products-filters/types";
import {
  FILTER_DIVIDER,
  FILTER_DIVIDER_WITH_EXCLUDING,
} from "~/components/products-layout/constants";
import { Nullable } from "~/types/general.types";

export interface ProductFilterQuery {
  key?: string;
  value?: string[];
}

const modifyPriceObjectToFilterValue = (filterValue: {
  start?: string;
  end?: string;
}) => {
  const isStartRange = Object.prototype.hasOwnProperty.call(filterValue, "start");
  const isEndRange = Object.prototype.hasOwnProperty.call(filterValue, "end");
  if (isStartRange && isEndRange) {
    return [`${filterValue?.start}`, `${filterValue?.end}`];
  }
};

const isPriceFilter = (joinedKey: string) => joinedKey === "sku_price";

export const splitFilters = (filterKey: string): string[] => {
  if (!filterKey) {
    return [];
  }
  return filterKey
    ?.split(FILTER_DIVIDER_WITH_EXCLUDING)
    ?.filter((key) => key !== FILTER_DIVIDER);
};

export const getFilterValuesForRequest = (
  appliedFilters?: Nullable<AppliedFilters>,
  isShopFilter?: Nullable<boolean>,
  currentShopId?: Nullable<string>,
  isRangedStoresFacet?: boolean,
): ProductFilterQuery[] => {
  let filters = Object.entries(appliedFilters ?? {}).reduce<ProductFilterQuery[]>(
    (acc, [filterKey, filterValue]) => {
      const [filterCategory, , filterRequestValue] = splitFilters(filterKey);
      const joinedKey = filterCategory?.split(" ")?.join("");

      const filterItem: ProductFilterQuery = {};

      let parsedFilterValue;

      try {
        parsedFilterValue = JSON.parse(filterRequestValue);

        if (typeof parsedFilterValue === "number") {
          parsedFilterValue = parsedFilterValue.toString();
        }
      } catch {
        parsedFilterValue = filterRequestValue;
      }

      if (filterValue) {
        const existingFilter = acc?.find((filter) => filter?.key === joinedKey);
        if (isPriceFilter(joinedKey)) {
          parsedFilterValue = modifyPriceObjectToFilterValue(parsedFilterValue);
        }
        if (existingFilter?.value) {
          existingFilter.value = isPriceFilter(joinedKey)
            ? [...existingFilter.value, ...parsedFilterValue]
            : [...existingFilter.value, parsedFilterValue];
        } else {
          filterItem.key = joinedKey;
          filterItem["value"] = isPriceFilter(joinedKey)
            ? [...parsedFilterValue]
            : [parsedFilterValue];
        }
      }

      if (!isEmpty(filterItem)) {
        acc = [...acc, filterItem];
      }

      return acc;
    },
    [],
  );

  if (isShopFilter && currentShopId) {
    const shopFilterValue = {
      key: isRangedStoresFacet ? "rangedStores" : "stores",
      value: [currentShopId],
    };
    filters = [...filters, shopFilterValue];
  }

  return filters;
};
